import wrapWithProvider from './src/state/reduxWrapper';
export const wrapRootElement = wrapWithProvider
